/* Generated file. Do not modify. Please check more details in build/generate.ts */
import * as React from "react";
import type { IconProps } from "../IconTypes";
import { IconWrapper } from "../IconWrapper";
export function DockLeftIcon(props: IconProps) {
    return (<IconWrapper {...props}>
            {<path fillRule="evenodd" clipRule="evenodd" d="M4 10a4 4 0 0 1 4-4h24a4 4 0 0 1 4 4v20a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4zm11-1h17a1 1 0 0 1 1 1v20a1 1 0 0 1-1 1H15zm-3 0H8a1 1 0 0 0-1 1v20a1 1 0 0 0 1 1h4z"/>}
        </IconWrapper>);
}
